import { GetConciliacionBancariaByIdDtoProps } from "./DTOs/GetConciliacionBancariaByIdDto"

export const getConciliacionBancariaIdAdapter = (
  conciliacion: GetConciliacionBancariaByIdDtoProps
): GetConciliacionBancariaByIdDtoProps => ({
  id: conciliacion?.id,
  flujosTesoreria: conciliacion?.flujosTesoreria,
  movimientosBancarios: conciliacion?.movimientosBancarios,
})
